<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import AuTooltip from '~/components/utils/AuTooltip.vue'

const images = defineModel<string[]>('images')
const currentImage = defineModel<string>('currentImage')

const { t } = useI18n()
</script>

<template>
  <div class="absolute -bottom-12 left-0 flex h-max flex-col items-center rounded-xl bg-[--theme-10] p-4 md:left-auto md:right-[-118px] md:top-0 print:hidden">
    <ul class="flex gap-1 md:flex-col">
      <li
        v-for="(image, i) in images"
        :key="i"
      >
        <AuTooltip side="left" :content="t('formWriter.tooltips.chooseImage')">
          <button class="rounded focus-visible:ring" @click="currentImage = image">
            <img
              :src="image"
              class="aspect-video h-full w-20 rounded object-cover md:aspect-auto md:object-contain"
              alt=""
            >
          </button>
        </AuTooltip>
      </li>
    </ul>
  </div>
</template>
